import { MaterialConsumptionStateTypes, MaterialConsumptionActionTypes } from "./MaterialConsumption.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: MaterialConsumptionStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const MaterialConsumptionReducer = (
  state: MaterialConsumptionStateTypes = INITIAL_STATE,
  action: any
): MaterialConsumptionStateTypes => {
  switch (action.type) {
    case MaterialConsumptionActionTypes.FETCH_ALL_MATERIAL_CONSUMPTION:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialConsumptionActionTypes.FETCH_ALL_MATERIAL_CONSUMPTION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MaterialConsumptionActionTypes.FETCH_ALL_MATERIAL_CONSUMPTION_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialConsumptionActionTypes.FETCH_ALL_MATERIAL_CONSUMPTION_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case MaterialConsumptionActionTypes.FETCH_ONE_MATERIAL_CONSUMPTION:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialConsumptionActionTypes.FETCH_ONE_MATERIAL_CONSUMPTION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MaterialConsumptionActionTypes.FETCH_ONE_MATERIAL_CONSUMPTION_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialConsumptionActionTypes.FETCH_ONE_MATERIAL_CONSUMPTION_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default MaterialConsumptionReducer;
